import Vue from 'vue';
import Vuex from 'vuex';
import naviList from './modules/naviList';
import user from './modules/user';
import group from './modules/group';
import test from './modules/test';
import upload from './modules/upload';
import asset from './modules/asset';
import search from './modules/search';
import dashboard from './modules/dashboard';
import objectData from './modules/objectData';
import snackbar from './modules/snackbar';
import livestatus from './modules/livestatus';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    naviList,
    user,
    group,
    test,
    upload,
    asset,
    search,
    dashboard,
    objectData,
    snackbar,
    livestatus
  },
});